import { ModelManagement } from "@/components/ModelManagement";
import { useNavigate } from "react-router-dom";

export const SettingsPage = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate("/");
  return <ModelManagement onBack={handleBack} />;
};
